import { defineAsyncComponent } from 'vue'
export default {
  agent: defineAsyncComponent(() => import("/var/www/lottobox-agent/layouts/agent.vue").then(m => m.default || m))
}